import {ajaxGetData} from 'methods/ajaxData';
import {escapeHtml, isStaff} from 'methods/utils';

const COOKIE_KEY_PREFIX = 'booking_unpaid_toast_closed_';

function isBookingPageWithoutUnpaidPopup() {
    const {pathname} = window.location;

    return /^\/lk(\/|$)/.test(pathname) || /^\/my\/booking(\/|$)/.test(pathname);
}

const CLOSE_ICON_SVG = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2071 6.20701C19.3892 6.01841 19.49 5.76581 19.4878 5.50361C19.4855 5.24141 19.3803 4.9906 19.1949 4.80519C19.0095 4.61978 18.7587 4.51461 18.4965 4.51234C18.2343 4.51006 17.9817 4.61085 17.7931 4.79301L12.0001 10.586L6.20708 4.79301C6.01848 4.61085 5.76588 4.51006 5.50368 4.51234C5.24148 4.51461 4.99067 4.61978 4.80526 4.80519C4.61985 4.9906 4.51469 5.24141 4.51241 5.50361C4.51013 5.76581 4.61092 6.01841 4.79308 6.20701L10.5861 12L4.79308 17.793C4.69757 17.8853 4.62139 17.9956 4.56898 18.1176C4.51657 18.2396 4.48898 18.3708 4.48783 18.5036C4.48668 18.6364 4.51198 18.7681 4.56226 18.891C4.61254 19.0139 4.68679 19.1255 4.78069 19.2194C4.87458 19.3133 4.98623 19.3876 5.10913 19.4378C5.23202 19.4881 5.3637 19.5134 5.49648 19.5123C5.62926 19.5111 5.76048 19.4835 5.88249 19.4311C6.00449 19.3787 6.11483 19.3025 6.20708 19.207L12.0001 13.414L17.7931 19.207C17.9817 19.3892 18.2343 19.49 18.4965 19.4877C18.7587 19.4854 19.0095 19.3802 19.1949 19.1948C19.3803 19.0094 19.4855 18.7586 19.4878 18.4964C19.49 18.2342 19.3892 17.9816 19.2071 17.793L13.4141 12L19.2071 6.20701Z" fill="currentColor"/>
</svg>`;

function getUnpaidPopupAnchor() {
    const $bookingCounter = document.querySelector('.js-bookingCounter');
    const $userMenu = document.querySelector('.js-headerUserMenuOpen');

    if ($userMenu && (!$bookingCounter || window.tourist_auth?.id)) {
        return $userMenu;
    }

    return $bookingCounter || $userMenu;
}

function renderToast(order) {
    const imageBlock = order.image
        ? `<div class="Booking-unpaidToast__image">
            <img src="${escapeHtml(order.image)}" alt="${escapeHtml(order.hotel_title)}" loading="lazy">
        </div>`
        : '';

    return `
        <div class="Booking-unpaidToast js-booking-unpaid-toast" data-order-id="${escapeHtml(String(order.id))}" hidden>
            <div class="Booking-unpaidToast__arrow" aria-hidden="true"></div>
            <div class="Booking-unpaidToast__body">
                ${imageBlock}
                <div class="Booking-unpaidToast__info">
                    <a class="Booking-unpaidToast__hotelLink" href="${escapeHtml(order.hotel_url)}">
                        ${escapeHtml(order.hotel_title)}
                    </a>
                    <div class="Booking-unpaidToast__summary">${escapeHtml(order.summary)}</div>
                    <div class="Booking-unpaidToast__status">Ожидает оплаты</div>
                </div>
            </div>
            <div class="Booking-unpaidToast__actions">
                <a class="Booking-unpaidToast__payButton" href="${escapeHtml(order.payment_url)}">
                    Оплатить ${escapeHtml(order.price_format)}&nbsp;₽
                </a>
                <button
                    type="button"
                    class="Booking-unpaidToast__close js-booking-unpaid-toast-close"
                    aria-label="Пропустить"
                >
                    ${CLOSE_ICON_SVG}
                </button>
                <button
                    type="button"
                    class="Booking-unpaidToast__hide js-booking-unpaid-toast-close"
                >
                    Скрыть
                </button>
            </div>
        </div>
    `;
}

function mountBookingUnpaidPopup(orders) {
    if (!orders?.length || document.querySelector('.js-booking-unpaidToasts')) {
        return false;
    }

    const container = document.createElement('div');
    container.className = 'Booking-unpaidToasts js-booking-unpaidToasts';
    container.setAttribute('aria-live', 'polite');
    container.hidden = true;
    container.innerHTML = `
        <div class="Booking-unpaidToasts__overlay" aria-hidden="true"></div>
        ${orders.map(renderToast).join('')}
    `;

    document.body.appendChild(container);
    return true;
}

export function repositionVisibleUnpaidPopup() {
    if (isBookingPageWithoutUnpaidPopup()) {
        return;
    }

    const container = document.querySelector('.js-booking-unpaidToasts');
    if (container && !container.hidden) {
        positionNearBookingCounter(container);
    }
}

function positionNearBookingCounter(container) {
    const anchor = getUnpaidPopupAnchor();
    const toast = container.querySelector('.js-booking-unpaid-toast');
    const arrow = toast?.querySelector('.Booking-unpaidToast__arrow');

    if (!anchor) {
        container.style.top = '88px';
        container.style.right = '24px';
        container.style.left = 'auto';

        if (arrow) {
            arrow.style.left = '';
        }

        return;
    }

    const rect = anchor.getBoundingClientRect();
    const width = container.offsetWidth || 360;
    let left = rect.left + rect.width / 2 - width / 2;

    left = Math.max(12, Math.min(left, window.innerWidth - width - 12));

    container.style.top = `${rect.bottom + 12}px`;
    container.style.left = `${left}px`;
    container.style.right = 'auto';

    if (arrow) {
        arrow.style.left = `${rect.left + rect.width / 2 - left}px`;
    }
}

function tryShowUnpaidPopup(orders) {
    if (isBookingPageWithoutUnpaidPopup()) {
        return;
    }

    if (!orders?.length) {
        return;
    }

    const container = document.querySelector('.js-booking-unpaidToasts');

    if (!container) {
        if (!mountBookingUnpaidPopup(orders)) {
            return;
        }
    }

    initBookingUnpaidPopup();
}

function loadUnpaidOrdersFromAjax() {
    ajaxGetData().then((response) => {
        tryShowUnpaidPopup(response.data?.unpaid_orders || null);
        repositionVisibleUnpaidPopup();
    });
}

function pauseUnpaidPopupForUserMenu() {
    const container = document.querySelector('.js-booking-unpaidToasts');
    if (!container || container.hidden) {
        return;
    }

    container.dataset.pausedByUserMenu = '1';
    container.hidden = true;
}

function resumeUnpaidPopupAfterUserMenu() {
    const container = document.querySelector('.js-booking-unpaidToasts');
    if (!container || container.dataset.pausedByUserMenu !== '1') {
        return;
    }

    delete container.dataset.pausedByUserMenu;
    container.hidden = false;
    positionNearBookingCounter(container);
}

let userMenuUnpaidPopupBehaviorBound = false;

function bindUserMenuUnpaidPopupBehavior() {
    if (userMenuUnpaidPopupBehaviorBound) {
        return;
    }

    userMenuUnpaidPopupBehaviorBound = true;
    document.addEventListener('header-user-menu:open', pauseUnpaidPopupForUserMenu);
    document.addEventListener('header-user-menu:close', resumeUnpaidPopupAfterUserMenu);
}

export function initBookingUnpaidPopupFromAjax() {
    if (isBookingPageWithoutUnpaidPopup()) {
        document.querySelector('.js-booking-unpaidToasts')?.remove();
        return;
    }

    bindUserMenuUnpaidPopupBehavior();

    document.addEventListener('booking-counter:ready', loadUnpaidOrdersFromAjax);
    document.addEventListener('header-user-menu:ready', () => {
        loadUnpaidOrdersFromAjax();
        repositionVisibleUnpaidPopup();
    });
    loadUnpaidOrdersFromAjax();
}

export default function initBookingUnpaidPopup() {
    if (isBookingPageWithoutUnpaidPopup()) {
        document.querySelector('.js-booking-unpaidToasts')?.remove();
        return;
    }

    const container = document.querySelector('.js-booking-unpaidToasts');
    if (!container || container.dataset.initialized === '1') {
        if (container && container.hidden === false) {
            positionNearBookingCounter(container);
        }
        return;
    }

    const isMobile = document.body?.dataset?.is_mobile === '1';

    const toasts = [...container.querySelectorAll('.js-booking-unpaid-toast')];
    if (!toasts.length) {
        container.remove();
        return;
    }

    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
        return null;
    }

    function setCookie(name, value, days = 30) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; SameSite=Lax`;
    }

    const visibleToasts = [];

    toasts.forEach((toast) => {
        const orderId = toast.dataset.orderId;
        const isClosed = getCookie(COOKIE_KEY_PREFIX + orderId) === '1';

        if (isClosed) {
            toast.remove();
            return;
        }

        if (visibleToasts.length) {
            toast.remove();
            return;
        }

        toast.hidden = false;
        visibleToasts.push(toast);
    });

    if (!visibleToasts.length) {
        container.remove();
        return;
    }

    container.hidden = false;
    container.dataset.initialized = '1';

    if (!isMobile) {
        const updatePosition = () => positionNearBookingCounter(container);

        updatePosition();
        window.addEventListener('resize', updatePosition);
        window.addEventListener('scroll', updatePosition, { passive: true });
        document.addEventListener('booking-counter:ready', updatePosition);
        document.addEventListener('header-user-menu:ready', updatePosition);
    } else {
        container.style.top = 'auto';
        container.style.bottom = '0';
        container.style.left = '0';
        container.style.right = '0';
        container.style.width = '100%';
        container.style.maxWidth = 'none';
    }

    container.addEventListener('click', (event) => {
        const closeButton = event.target.closest('.js-booking-unpaid-toast-close');
        if (!closeButton) {
            return;
        }

        const toast = closeButton.closest('.js-booking-unpaid-toast');
        if (!toast) {
            return;
        }

        const days = isStaff() ? 3 : 30;
        setCookie(COOKIE_KEY_PREFIX + toast.dataset.orderId, '1', days);
        toast.remove();

        if (!container.querySelector('.js-booking-unpaid-toast')) {
            container.remove();
        }
    });
}
